import { initConfig } from "./config.js";
import { showWelcome } from "./lib/welcome.js";
import { registerSettings } from "./settings.js";
import { TokenNotes } from "./app/TokenNotes.js";

export const MODULE_ID = "token-notes";

Hooks.on("init", () => {
    registerSettings();
    ui.TokenNotes = new TokenNotes();
});

Hooks.on("ready", () => {
    showWelcome();
    initConfig();
});
